<div [class.nested-component]="isNestedComponent">
  <div class="filters row" *ngIf="!isNestedComponent">
    <div class="col-md-3">
      <app-searchable-select
        [options]="centres$ | async"
        displayKey="centreName"
        [valueKey]="'centreCode'"
        [multiple]="true"
        [hideSelectAllOption]="false"
        placeholder="Enter Centre(s) Name"
        label="Select Centre(s)"
        [selectedValue]="selectedCentreObjects"
        (selectionChange)="onCentresSelected($event)"
      ></app-searchable-select>
    </div>
    <mat-form-field appearance="outline" class="col-md-4">
      <mat-label>Date Range</mat-label>
      <mat-date-range-input [rangePicker]="rangePicker">
        <input matStartDate [(ngModel)]="startDate" placeholder="Start date">
        <input matEndDate [(ngModel)]="endDate" placeholder="End date">
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
      <mat-date-range-picker #rangePicker></mat-date-range-picker>
    </mat-form-field>
    <div class="col-md-3 d-flex gap-2">
      <button mat-mini-fab color="accent" (click)="search()"><mat-icon>search</mat-icon></button>
      <button mat-mini-fab color="accent" (click)="clearFilters()"><mat-icon>clear</mat-icon></button>
    </div>
  </div>

  <div *ngIf="loading" class="spinner-container">
    <mat-spinner diameter="32" strokeWidth="3"></mat-spinner>
    <span class="spinner-label">Loading…</span>
  </div>

  <mat-tab-group>

    <!-- CHILD TAB -->
    <mat-tab [label]="'Child (' + childCount + ')'">
      <div class="mat-elevation-z8">
        <table mat-table [dataSource]="childDataSource" matSort #childSort="matSort">
          <ng-container matColumnDef="centreName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Centre </th>
            <td mat-cell *matCellDef="let element"> {{element.centreName}} </td>
          </ng-container>
          <ng-container matColumnDef="childName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Child Name </th>
            <td mat-cell *matCellDef="let element"> {{element.childName}} </td>
          </ng-container>
          <ng-container matColumnDef="dateRange">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
            <td mat-cell *matCellDef="let element"> {{getDateRange(element)}} </td>
          </ng-container>
          <ng-container matColumnDef="sessionType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Session Type </th>
            <td mat-cell *matCellDef="let element"> {{getSessionType(element)}} </td>
          </ng-container>
          <ng-container matColumnDef="challenges">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Challenges </th>
            <td mat-cell *matCellDef="let element"> {{getChallenges(element)}} </td>
          </ng-container>
          <ng-container matColumnDef="remark">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Remark </th>
            <td mat-cell *matCellDef="let element">
              <div>{{getRemark(element)}}</div>
              <button mat-icon-button (click)="openEditRemarkDialog(element)" *ngIf="isGranted(PermissionType.ADD)">
                <mat-icon>edit</mat-icon>
              </button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="childColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: childColumns;"></tr>
        </table>
        <mat-paginator #childPaginator [pageSizeOptions]="[5, 10, 20]"></mat-paginator>
      </div>
    </mat-tab>

    <!-- TEEN TAB -->
    <mat-tab [label]="'Teen (' + teenCount + ')'">
      <div class="mat-elevation-z8">
        <table mat-table [dataSource]="teenDataSource" matSort #teenSort="matSort">
          <ng-container matColumnDef="centreName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Centre </th>
            <td mat-cell *matCellDef="let element"> {{element.centreName}} </td>
          </ng-container>
          <ng-container matColumnDef="childName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Child Name </th>
            <td mat-cell *matCellDef="let element"> {{element.childName}} </td>
          </ng-container>
          <ng-container matColumnDef="dateRange">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
            <td mat-cell *matCellDef="let element"> {{getDateRange(element)}} </td>
          </ng-container>
          <ng-container matColumnDef="sessionType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Session Type </th>
            <td mat-cell *matCellDef="let element"> {{getSessionType(element)}} </td>
          </ng-container>
          <ng-container matColumnDef="challenges">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Challenges </th>
            <td mat-cell *matCellDef="let element"> {{getChallenges(element)}} </td>
          </ng-container>
          <ng-container matColumnDef="remark">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Remark </th>
            <td mat-cell *matCellDef="let element">
              <div [class.expanded-remark]="expandedRemarks[element.id]">{{getRemark(element)}}</div>
              <button mat-icon-button (click)="toggleRemark(element.id)">
                <mat-icon>{{expandedRemarks[element.id] ? 'expand_less' : 'expand_more'}}</mat-icon>
              </button>
              <button mat-icon-button (click)="openEditRemarkDialog(element)" *ngIf="isGranted(PermissionType.ADD)">
                <mat-icon>edit</mat-icon>
              </button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="teenColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: teenColumns;"></tr>
        </table>
        <mat-paginator #teenPaginator [pageSizeOptions]="[5, 10, 20]"></mat-paginator>
      </div>
    </mat-tab>

    <!-- CAREGIVER TAB -->
    <mat-tab [label]="'Caregiver (' + caregiverCount + ')'">
      <div class="mat-elevation-z8">
        <table mat-table [dataSource]="caregiverDataSource" matSort #caregiverSort="matSort">
          <ng-container matColumnDef="centreName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Centre </th>
            <td mat-cell *matCellDef="let element"> {{element.centreName}} </td>
          </ng-container>
          <ng-container matColumnDef="childName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Child Name </th>
            <td mat-cell *matCellDef="let element"> {{element.childName}} </td>
          </ng-container>
          <ng-container matColumnDef="dateRange">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
            <td mat-cell *matCellDef="let element"> {{getDateRange(element)}} </td>
          </ng-container>
          <ng-container matColumnDef="sessionType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Session Type </th>
            <td mat-cell *matCellDef="let element"> {{getSessionType(element)}} </td>
          </ng-container>
          <ng-container matColumnDef="relation">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Relation </th>
            <td mat-cell *matCellDef="let element"> {{getRelation(element)}} </td>
          </ng-container>
          <ng-container matColumnDef="challenges">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Challenges </th>
            <td mat-cell *matCellDef="let element"> {{getChallenges(element)}} </td>
          </ng-container>
          <ng-container matColumnDef="remark">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Remark </th>
            <td mat-cell *matCellDef="let element">
              <div [class.expanded-remark]="expandedRemarks[element.id]">{{getRemark(element)}}</div>
              <button mat-icon-button (click)="toggleRemark(element.id)">
                <mat-icon>{{expandedRemarks[element.id] ? 'expand_less' : 'expand_more'}}</mat-icon>
              </button>
              <button mat-icon-button (click)="openEditRemarkDialog(element)" *ngIf="isGranted(PermissionType.ADD)">
                <mat-icon>edit</mat-icon>
              </button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="caregiverColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: caregiverColumns;"></tr>
        </table>
        <mat-paginator #caregiverPaginator [pageSizeOptions]="[5, 10, 20]"></mat-paginator>
      </div>
    </mat-tab>

  </mat-tab-group>
</div>
